import { render, staticRenderFns } from "./ContestFinalistComponent.vue?vue&type=template&id=e3ac60bc"
import script from "./ContestFinalistComponent.vue?vue&type=script&lang=js"
export * from "./ContestFinalistComponent.vue?vue&type=script&lang=js"
import style0 from "./ContestFinalistComponent.vue?vue&type=style&index=0&id=e3ac60bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports